const Cookie = {
    get(name) {
        try {
            const re = new RegExp(name + "=([^;]+)");
            const value = re.exec(document.cookie);
            return (value != null) ? unescape(value[1]) : null;
        } catch (e) {
            return null;
        }
    },
    set(name,value) {
        const now = new Date();
        const time = now.getTime();
        const expireTime = time + 1000*36000;
        now.setTime(expireTime);
        //const tempExp = 'Wed, 31 Oct 2012 08:50:17 GMT';
        document.cookie = name + "=" + value + ";expires=" + now.toGMTString() + ";path=/";
    },
    remove(name, {path="/",domain=".mybidwin.com"}={}) {
    	var d = new Date(); 
    	d.setTime(d.getTime() - (1000*60*60*24)); 
    	var expires = "expires="+d.toGMTString();
    	document.cookie = name+"=: "+"domain="+`${domain};path=${path};`+expires;
    },
    setToPath(name,value,domain) {
        const now = new Date();
        const time = now.getTime();
        const expireTime = time + 1000*36000;
        now.setTime(expireTime);
        //const tempExp = 'Wed, 31 Oct 2012 08:50:17 GMT';
        document.cookie = name + "=" + value + ";expires=" + now.toGMTString() + ";domain="+domain+";path=/";
    }
};

module.exports = Cookie;


// WEBPACK FOOTER //
// ./src/util/Cookie.js